import * as XLSX from 'xlsx';
import { ReportMovementDTO } from '../types';

export function exportMovementsToExcel(
  movements: ReportMovementDTO[],
  cashBoxName: string,
  currency: string,
  startDate: string,
  endDate: string
): void {
  const currencySymbol = currency === 'USD' ? 'US$' : '$';

  const rows = movements.map((mov) => {
    const parsedDate = new Date(mov.date);
    const fecha = parsedDate.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const hora =
      mov.date.includes('T') && !mov.date.endsWith('T00:00:00')
        ? parsedDate.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
        : '';

    return {
      Fecha: fecha,
      Hora: hora,
      Descripción: mov.description || 'Movimiento de caja',
      Referencia: mov.transactionId ? `TXN-${mov.transactionId}` : '',
      'Tipo de Movimiento': mov.transactionType || '',
      'Débito/Crédito': mov.entryType === 'CREDITO' ? 'Crédito' : 'Débito',
      [`Monto (${currency})`]:
        `${mov.entryType === 'CREDITO' ? '+' : '-'}${currencySymbol} ${mov.amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      'Monto Numérico': mov.entryType === 'CREDITO' ? mov.amount : -mov.amount,
    };
  });

  const ws = XLSX.utils.json_to_sheet(rows);

  // Column widths
  ws['!cols'] = [
    { wch: 12 },
    { wch: 8 },
    { wch: 40 },
    { wch: 14 },
    { wch: 20 },
    { wch: 14 },
    { wch: 18 },
    { wch: 18 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');

  const safeName = cashBoxName.replace(/[^a-zA-Z0-9_\- ]/g, '').trim().slice(0, 30);
  const filename = `Movimientos_${safeName}_${startDate}_${endDate}.xlsx`;

  XLSX.writeFile(wb, filename);
}
